module.exports = __webpack_public_path__ + "media/images/icon/square-f10f031ce338653f1205ecd462351efe.svg";